"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_STYLE_PUSH_UNAVAILABLE = exports.LIST_STYLE_PUSH_AVAILABLE = exports.LIST_STYLE_EXPIRED = exports.LIST_STYLE_DEFAULT = exports.BIND_STATUS_INVALID = exports.LOADING_DURATION = exports.UID_MASK_END = exports.UID_MASK_START = exports.LOAD_TIMEOUT = exports.PAD_LENGTH = exports.TIMESTAMP_MILLISECOND = exports.TIMESTAMP_SECOND_LENGTH = exports.PAGE_SIZE = exports.DEFAULT_OPTION = void 0;
exports.DEFAULT_OPTION = {
    actionIds: '0',
    content: '未完成',
    pushAvailableContent: '可提醒',
    pushUnavailableContent: '已提醒',
    pushSuccessToast: '已发送提醒',
    pushedToast: '今日已提醒，请明日再来',
    pushFailedToast: '发送失败，请稍后重试',
    expiredStateContent: '已过期'
};
exports.PAGE_SIZE = 10;
// 时间戳相关常量
exports.TIMESTAMP_SECOND_LENGTH = 10; // 秒级时间戳长度
exports.TIMESTAMP_MILLISECOND = 1000; // 毫秒转换倍数
exports.PAD_LENGTH = 2; // 日期格式化补零长度
// 加载超时时间（毫秒）
exports.LOAD_TIMEOUT = 1000;
// UID 脱敏显示相关常量
exports.UID_MASK_START = 2; // 显示前几位
exports.UID_MASK_END = 2; // 显示后几位
exports.LOADING_DURATION = 3; // loading 显示时长（秒）
/** 邀请记录已失效（过期），与后端 BindStatus.INVALID 一致 */
exports.BIND_STATUS_INVALID = 0;
/** 列表行右侧展示样式类型（与 List 组件约定） */
exports.LIST_STYLE_DEFAULT = 0;
exports.LIST_STYLE_EXPIRED = 1;
exports.LIST_STYLE_PUSH_AVAILABLE = 2;
exports.LIST_STYLE_PUSH_UNAVAILABLE = 3;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsY0FBYyxHQUFHO0lBQzFCLFNBQVMsRUFBRSxHQUFHO0lBQ2QsT0FBTyxFQUFFLEtBQUs7SUFDZCxvQkFBb0IsRUFBRSxLQUFLO0lBQzNCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsZ0JBQWdCLEVBQUUsT0FBTztJQUN6QixXQUFXLEVBQUUsYUFBYTtJQUMxQixlQUFlLEVBQUUsWUFBWTtJQUM3QixtQkFBbUIsRUFBRSxLQUFLO0NBQzdCLENBQUM7QUFFVyxRQUFBLFNBQVMsR0FBRyxFQUFFLENBQUM7QUFFNUIsVUFBVTtBQUNHLFFBQUEsdUJBQXVCLEdBQUcsRUFBRSxDQUFDLENBQUMsVUFBVTtBQUN4QyxRQUFBLHFCQUFxQixHQUFHLElBQUksQ0FBQyxDQUFDLFNBQVM7QUFDdkMsUUFBQSxVQUFVLEdBQUcsQ0FBQyxDQUFDLENBQUMsWUFBWTtBQUV6QyxhQUFhO0FBQ0EsUUFBQSxZQUFZLEdBQUcsSUFBSSxDQUFDO0FBQ2pDLGVBQWU7QUFDRixRQUFBLGNBQWMsR0FBRyxDQUFDLENBQUMsQ0FBQyxRQUFRO0FBQzVCLFFBQUEsWUFBWSxHQUFHLENBQUMsQ0FBQyxDQUFDLFFBQVE7QUFFMUIsUUFBQSxnQkFBZ0IsR0FBRyxDQUFDLENBQUMsQ0FBQyxrQkFBa0I7QUFFckQsNENBQTRDO0FBQy9CLFFBQUEsbUJBQW1CLEdBQUcsQ0FBQyxDQUFDO0FBRXJDLCtCQUErQjtBQUNsQixRQUFBLGtCQUFrQixHQUFHLENBQUMsQ0FBQztBQUN2QixRQUFBLGtCQUFrQixHQUFHLENBQUMsQ0FBQztBQUN2QixRQUFBLHlCQUF5QixHQUFHLENBQUMsQ0FBQztBQUM5QixRQUFBLDJCQUEyQixHQUFHLENBQUMsQ0FBQyJ9